<div class="content">
	<div>
		<div class="row">
			<div class="col-md-12 form-group">
				<label class="form-check-label">
					<input type="checkbox" [(ngModel)]="expandFilename">
					Download with full underscored filename
				</label>
			</div>
		</div>
		<div class="form-group row">
			<label class="col-md-4">Start Date (UTC):</label>
			<div class="col-md-8">
				<app-day-picker [(ngModel)]="startDate" (ngModelChange)="RefreshData()"></app-day-picker>
			</div>
		</div>
		<div class="form-group row">
			<label class="col-md-4">End Date (UTC):</label>
			<div class="col-md-8">
				<app-day-picker [(ngModel)]="endDate" (ngModelChange)="RefreshData()"></app-day-picker>
			</div>
		</div>
		<div *ngIf="datafiles === undefined" class="text-center">
			<div class="logo-spin light"></div>
			Loading...
		</div>
		<table *ngIf="datafiles" class="datafile-table">
			<tr>
				<th>Filename</th>
				<th>Size</th>
				<th>File Type</th>
				<th>Import Date ▼</th>
			</tr>
			<tr *ngFor="let datafile of datafiles; let i = index" class="listing-item"
				[class.dayspacer]="(datafiles.length > i + 1) && (datafile.imported.clone().startOf('day') > datafiles[i + 1].imported.clone().startOf('day'))">
				<td><a (click)="DownloadFile(datafile)" href="javascript:void(0)"><i class="icon-doc"></i> {{datafile.filename | truncatedfile}}</a></td>
				<td>{{ datafile.size | filesize }}</td>
				<td>{{ datafile.filetype }}</td>
				<td>{{ datafile.imported | datetime : "local" }}</td>
			</tr>
		</table>
		<div *ngIf="datafiles && datafiles.length === 0" class="mt-3 text-center">
			No datafiles found.
		</div>
	</div>
</div>